import { useDispatch, useSelector } from "react-redux";
import { userSlice } from "./UserStore";
import { RootState } from "../app/Store";
import { useKeyStrokeDetector } from "../../common/useKeyStrokeDetector";
import { UserAccessType } from "./Models";

const SudoModeListener = () => {
  const sudoMode = useSelector((state: RootState) => state.user.sudoMode);
  const originalUserType = useSelector((state: RootState) => state.user.originalUserType);
  const dispatch = useDispatch();
  useKeyStrokeDetector("iddqd", () => {
    console.log(`Sudo mode ${sudoMode ? "de" : ""}activated!`);
    dispatch(userSlice.actions.setSudoMode(!sudoMode));
  });
  useKeyStrokeDetector("viewermode", () => {
    console.log(`Viewer mode ${originalUserType ? "de" : ""}activated!`);
    dispatch(userSlice.actions.impersonateAs(originalUserType || UserAccessType.Viewer));
  });
  useKeyStrokeDetector("operatormode", () => {
    console.log(`Operator mode ${originalUserType ? "de" : ""}activated!`);
    dispatch(userSlice.actions.impersonateAs(originalUserType || UserAccessType.Operator));
  });
  return <></>;
};

export default SudoModeListener;
